<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId">
  <!-- Top Bar: Route Summary (matching list item style but for drilldown) -->
  <app-planning-draft-routes-table-list-item [route]="route"
                                             [logisticsVehicleName]="logisticsVehicleName"
                                             [settings]="settings.routes"
                                             [isVisible]="visibleKeys[route.id]"
                                             [canClose]="true"
                                             [itemElementSize]="itemElementSize"
                                             [isShowActionMenu]="true"
                                             [isGroupedRoutes]="isGroupedRoutes"
                                             (onDispatch)="onDispatch.emit($event)"
                                             (onPrint)="onPrint.emit($event)"
                                             (onDelete)="onDelete.emit($event)"
                                             (onClose)="onClose.emit()"
                                             (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                                             (onReoptimize)="onReoptimize.emit($event)"
                                             (onPreAssignAgent)="onPreAssignAgent.emit($event)"
                                             (onLockRouteChange)="onLockRouteChange.emit($event)"
                                             (onToggleVisible)="onToggleVisibleRoute(route.id, $event)"
                                             (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                             (onChangeRouteResource)="onChangeRouteResource.emit($event)"
                                             (onToggleGroupedRoutes)="onToggleGroupedRoutes.emit()">
  </app-planning-draft-routes-table-list-item>

  <!-- Header -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="columnGroups"
       [settings]="settings?.route"
       (settingsChange)="onRouteSettingsChange($event)">
    <div class="table-inner-wrapper">
      <div class="activities-table-list-container">
        <div class="tr sticky-header">
          @if (settings?.route?.columns?.id) {
            <div class="th col-id sticky-col" translate>
              ID
              <app-table-column-insert-button></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.type) {
            <div class="th col-type" translate>
              Type
              <app-table-column-insert-button column="type"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.account) {
            <div class="th col-account" translate>
              Account
              <app-table-column-insert-button column="account"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.accountExternalId) {
            <div class="th col-account-ext-id" translate>
              Account External ID
              <app-table-column-insert-button column="accountExternalId"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.contacts) {
            <div class="th col-contact" translate>
              Contacts
              <app-table-column-insert-button column="contacts"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.distance) {
            <div class="th col-distance" translate>
              Distance
              <app-table-column-insert-button column="distance"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.timeWindow) {
            <div class="th col-time-window" translate>
              Time Window
              <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.timeEstimations) {
            <div class="th col-eta" translate>
              ETA
              <app-table-column-insert-button column="timeEstimations"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.address) {
            <div class="th col-address" translate>
              Address
              <app-table-column-insert-button column="address"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.serviceTime) {
            <div class="th col-service-time" translate>
              Service Time
              <app-table-column-insert-button column="serviceTime"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.sla) {
            <div class="th col-sla" translate>
              SLA
              <app-table-column-insert-button column="sla"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.packages) {
            <div class="th col-load" translate>
              Packages
              <app-table-column-insert-button column="packages"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.load?.weight) {
            <div class="th col-load-weight" translate>
              Weight
              <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.load?.volume) {
            <div class="th col-load-volume" translate>
              Volume
              <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.load?.value) {
            <div class="th col-load-value" translate>
              Value
              <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.load?.pallets) {
            <div class="th col-load-pallets" translate>
              Pallets
              <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.load?.spots) {
            <div class="th col-load-spots" translate>
              Spots
              <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.capacity) {
            <div class="th col-capacity" translate>
              Capacity
              <app-table-column-insert-button></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.barcodes) {
            <div class="th col-barcodes" translate>
              Barcodes
              <app-table-column-insert-button column="barcodes"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.labels) {
            <div class="th col-labels" translate>
              Labels
              <app-table-column-insert-button column="labels"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.vehicles) {
            <div class="th col-vehicles" translate>
              Vehicles
              <app-table-column-insert-button column="vehicles"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.route?.columns?.recurringServiceTemplateId) {
            <div class="th col-recurring" translate>
              Recurring
              <app-table-column-insert-button column="recurringServiceTemplateId"></app-table-column-insert-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="body-container"
       #bodyContainer
       (scroll)="onBodyScroll($event)"
       cdkDropList
       [cdkDropListData]="route.activities"
       [id]="panel.id"
       [cdkDropListConnectedTo]="connectedPanelIds"
       [cdkDropListDisabled]="!!isLoading || route.locked || isRunning || route.status === 'DISPATCHED'"
       [cdkDropListSortPredicate]="sortPredicate"
       (cdkDropListEntered)="enter($event)"
       (cdkDropListDropped)="drop($event)">

    <div class="table-inner-wrapper">
      <div class="activities-table-list-container">
        <ng-container *ngFor="let activity of route.activities; let index = index; trackBy: trackById">

          <!-- Activity Row -->
          <div class="tr"
               [ngClass]="{
                 'selected': selectedKeys[activity.id],
                 'start-end-row': activity.type === 'START' || activity.type === 'END',
                 'highlight': queryText && (activity.address?.city?.toLowerCase()?.includes(queryText.toLowerCase()) || (activity.externalId || activity.jobId || '').toLowerCase().includes(queryText.toLowerCase()))
               }"
               cdkDrag
               [cdkDragDisabled]="(activity.type === 'START' || activity.type === 'END') || (!!isLoading || route.locked || isRunning || route.status === 'DISPATCHED')"
               [cdkDragData]="activity">

            <!-- Start / End Row Unified Layout -->
            <ng-container *ngIf="activity.type === 'START' || activity.type === 'END'">
              <div *ngIf="settings?.route?.columns?.id" class="td col-id sticky-col"></div>
              <div class="td col-time-indication">
                <div class="layout-row layout-align-start-center gap-5">
                  <bringoz-icon iconName="location-pin-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1 font-weight-600">{{ 'STOP_PURPOSE.' + activity.type | translate }}</span>
                  <span class="location-name text-ellipsis">{{ activity.address | bringozAddress }}</span>
                </div>
                <div class="layout-row layout-align-start-center gap-5 time-window-section">
                  <bringoz-icon iconName="timer-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="br-body-1">{{ activity | planningActivityTimeWindow }}</span>
                </div>
              </div>
            </ng-container>

            <!-- Normal Columns Layout -->
            <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
              <!-- ID / Checkbox -->
              <div *ngIf="settings?.route?.columns?.id" class="td col-id sticky-col layout-row layout-align-start-center">
                <div class="layout-row layout-align-start-center gap-5" style="min-width: 0; flex: 1;">
                  <div *ngIf="activity.type !== 'START' && activity.type !== 'END'" cdkDragHandle class="layout-row layout-align-start-center flex-none">
                    <bringoz-icon iconName="drag" class="secondary-100 pointer"></bringoz-icon>
                  </div>

                  <app-bringoz-checkbox *ngIf="activity.type !== 'START' && activity.type !== 'END'"
                                        class="flex-none"
                                        [isChecked]="selectedKeys[activity.id]"
                                        (clickEvent)="onSelectedChange(activity, !selectedKeys[activity.id])">
                  </app-bringoz-checkbox>
                  <!--Indexes In Route-->
                  <div *ngIf="activity.type !== 'START' && activity.type !== 'END'" class="index-in-route-container flex-none" [style.border-color]="routeColor">
                    <div [style.background]="(highlightedActivity?.id === activity.id) ? routeColor : (routeColor + '20')"
                         [style.color]="(highlightedActivity?.id === activity.id) ? 'white' : routeColor"
                         [style.border-color]="routeColor"
                         [ngbTooltip]="'Activity Index: ' + index"
                         container="body"
                         openDelay="300">
                      {{ index }}
                    </div>
                  </div>

                  <bringoz-icon *ngIf="activityDetailsMap[activity.id]?.isLocked"
                                class="flex-none"
                                iconName="lock"
                                classSize="md"
                                fill="#484848"
                                [ngbTooltip]="'Job is Locked' | translate"
                                openDelay="300">
                  </bringoz-icon>

                  <app-bringoz-state-link *ngIf="(jobsMap[activity.jobId]?.orderId && activity.type !== 'GROUP')"
                                          class="text-ellipsis"
                                          style="min-width: 0;"
                                          [appHighlightText]="queryText"
                                          [state]="'order.info'"
                                          [params]="{id : jobsMap[activity.jobId]?.orderId}"
                                          [text]="jobsMap[activity.jobId]?.externalId || jobsMap[activity.jobId]?.orderId">
                  </app-bringoz-state-link>

                  <span *ngIf="!(jobsMap[activity.jobId]?.orderId && activity.type !== 'GROUP') && activity.type !== 'GROUP'"
                        class="text-ellipsis font-weight-600"
                        style="min-width: 0;"
                        [ngbTooltip]="activity.type === 'START' ? ('START' | translate) : (activity.type === 'END' ? ('END' | translate) : (activity.externalId || activity.jobId || activity.id))"
                        container="body"
                        openDelay="300">
                     {{ activity.type === 'START' ? ('START' | translate) : (activity.type === 'END' ? ('END' | translate) : (activity.externalId || activity.jobId || activity.id)) }}
                  </span>

                  <span *ngIf="activity.type === 'GROUP'"
                        class="bundle-header br-body-1 text-ellipsis"
                        style="min-width: 0;"
                        [appHighlightText]="queryText"
                        [ngClass]="activity.stopType">
                    {{ 'Multi' | translate }} {{ activity.stopType | translate }}({{ activity.stopIds.length }})
                  </span>

                  <bringoz-button type="tertiary"
                                  size="fit"
                                  style="margin-left: auto;"
                                  [ngbTooltip]="'View Job Details' | translate"
                                  openDelay="300"
                                  (onClick)="onViewJob.emit({jobs: activityDetailsMap[activity.id]?.jobs, event: $event})">
                    <bringoz-icon iconName="info-outline" classSize="md" fill="#484848"></bringoz-icon>
                  </bringoz-button>

                  <div ngbDropdown container="body" class="flex-none">
                    <bringoz-button type="tertiary"
                                    size="fit"
                                    id="activity-action-menu-{{activity.id}}"
                                    (click)="$event.stopPropagation();"
                                    ngbDropdownToggle>
                      <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
                    </bringoz-button>
                    <div ngbDropdownMenu [attr.aria-labelledby]="'activity-action-menu-' + activity.id">
                      <button
                        ngbDropdownItem
                        type="tertiary"
                        [disabled]="route.locked"
                        (click)="onToggleLockJobs.emit({jobIds: activity.jobIds?.length ? activity.jobIds : [activity.jobId], isLocked: !activityDetailsMap[activity.id]?.isLocked});$event.stopPropagation()">
                        <div class="layout-row layout-align-start-center">
                          <bringoz-icon [iconName]="activityDetailsMap[activity.id]?.isLocked ? 'lock-open-outline' : 'lock'" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
                          <span class="br-body-2">{{(activityDetailsMap[activity.id]?.isLocked ? 'Unlock' : 'Lock') | translate}}</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Type Column -->
              <div *ngIf="settings?.route?.columns?.type" class="td col-type">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <app-task-purpose [purpose]="activity.stopType" firstLetterOnly="true"></app-task-purpose>
                  <span *ngIf="activity.type === 'GROUP'"
                        class="bundle-header font-weight-600"
                        [ngClass]="activity.stopType.toLowerCase() + '-color'">
                    {{ 'Multi' | translate }} {{ activity.stopType | translate }}({{ activity.stopIds.length }})
                  </span>
                  <span *ngIf="activity.type !== 'GROUP'"
                        class="bundle-header font-weight-600"
                        [ngClass]="activity.stopType.toLowerCase() + '-color'">
                    {{ activity.stopType | translate }}
                  </span>
                </ng-container>
              </div>

              <!-- Account Column -->
              <div *ngIf="settings?.route?.columns?.account" class="td col-account">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="account" classSize="md" fill="#484848"></bringoz-icon>
                  <app-bringoz-items-list-display [items]="activityDetailsMap[activity.id]?.accountsName"
                                                  [isTransparentBackground]="true"
                                                  maxItems="1">
                  </app-bringoz-items-list-display>
                </ng-container>
              </div>

              <!-- Account External ID Column -->
              <div *ngIf="settings?.route?.columns?.accountExternalId" class="td col-account-ext-id">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="hash" classSize="md"></bringoz-icon>
                  <span *ngIf="!activityDetailsMap[activity.id]?.accountExternalIds?.length" class="br-body-1 text-ellipsis">---</span>
                  <app-bringoz-items-list-display *ngIf="activityDetailsMap[activity.id]?.accountExternalIds?.length"
                                                  [items]="activityDetailsMap[activity.id]?.accountExternalIds"
                                                  [maxItems]="6">
                  </app-bringoz-items-list-display>
                </ng-container>
              </div>

              <!-- Contacts Column -->
              <div *ngIf="settings?.route?.columns?.contacts" class="td col-contact">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="contact-circle" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activityDetailsMap[activity.id]?.stopRef?.contact?.name || '---' }}</span>
                </ng-container>
              </div>

              <!-- Distance Column -->
              <div *ngIf="settings?.route?.columns?.distance" class="td col-distance">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="distance" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activity.distanceFromLastStopMeter | bringozDistance: '---':true }}</span>
                </ng-container>
              </div>

              <!-- Time Window -->
              <div *ngIf="settings?.route?.columns?.timeWindow" class="td col-time-window">
                <span class="text-ellipsis">{{ activity | timeWindow }}</span>
              </div>

              <!-- ETA -->
              <div *ngIf="settings?.route?.columns?.timeEstimations" class="td col-eta">
                <span class="text-ellipsis" [ngClass]="{'red-102': activity.delay > 0}">
                  {{ activity.eta | date:'HH:mm' }}
                </span>
              </div>

              <!-- Address -->
              <div *ngIf="settings?.route?.columns?.address" class="td col-address">
                <app-task-purpose *ngIf="activity.type !== 'START' && activity.type !== 'END'" [purpose]="activity.stopType" firstLetterOnly="true"></app-task-purpose>
                <span class="text-ellipsis">{{ activity.address | bringozAddress }}</span>
              </div>

              <!-- Service Time -->
              <div *ngIf="settings?.route?.columns?.serviceTime" class="td col-service-time">
                <span *ngIf="!activity.detailedServiceTime">{{ activity.serviceTime | bringozTimeConvert }}</span>
                <app-task-detailed-service-time *ngIf="!!activity.detailedServiceTime"
                                                 [isAllowEdit]="false"
                                                 [detailedServiceTime]="activity.detailedServiceTime">
                </app-task-detailed-service-time>
              </div>

              <!-- SLA Column -->
              <div *ngIf="settings?.route?.columns?.sla" class="td col-sla">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <span class="font-weight-600">SLA </span>
                  <span class="text-ellipsis">
                    {{ activityDetailsMap[activity.id]?.firstJob | bringozDate: 'sla' }} {{ activityDetailsMap[activity.id]?.firstJob | bringozTime: 'sla' }}
                  </span>
                </ng-container>
              </div>

              <!-- Packages -->
              <div *ngIf="settings?.route?.columns?.packages" class="td col-load">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="package-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activity.packages | planningPackagesPipe:false }}</span>
                </ng-container>
              </div>

              <!-- Weight -->
              <div *ngIf="settings?.route?.load?.weight" class="td col-load-weight">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="weight" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activity.packages | planningPackagesWeightPipe:true:true }}</span>
                </ng-container>
              </div>

              <!-- Volume -->
              <div *ngIf="settings?.route?.load?.volume" class="td col-load-volume">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="volume" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activity.packages | planningPackagesVolumePipe:true }}</span>
                </ng-container>
              </div>

              <!-- Value -->
              <div *ngIf="settings?.route?.load?.value" class="td col-load-value">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="dollar-circle" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activityDetailsMap[activity.id]?.firstJob?.price | bringozPrice }}</span>
                </ng-container>
              </div>

              <!-- Pallets -->
              <div *ngIf="settings?.route?.load?.pallets" class="td col-load-pallets">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="pallets" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activity.packages | planningPackagesPalletsPipe:false }}</span>
                </ng-container>
              </div>

              <!-- Spots -->
              <div *ngIf="settings?.route?.load?.spots" class="td col-load-spots">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="spot" classSize="md" fill="#484848"></bringoz-icon>
                  <span class="text-ellipsis">{{ activity.packages | planningPackagesSpotsPipe:true }}</span>
                </ng-container>
              </div>

              <!-- Capacity -->
              <div *ngIf="settings?.route?.capacity" class="td col-capacity">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <ng-container *ngIf="activityDetailsMap[activity.id]?.capacity as cap">
                    <bringoz-icon [iconName]="cap.icon" classSize="md"></bringoz-icon>
                    <app-bringoz-capacity-bar class="flex" [value]="cap.percentage"></app-bringoz-capacity-bar>
                    <span class="br-body-1">{{cap.percentage}}%</span>
                  </ng-container>
                  <span *ngIf="!activityDetailsMap[activity.id]?.capacity">---</span>
                </ng-container>
              </div>

              <!-- Barcodes Column -->
              <div *ngIf="settings?.route?.columns?.barcodes" class="td col-barcodes">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="barcode" classSize="md" fill="#484848"></bringoz-icon>
                  <app-bringoz-items-list-display [items]="activityDetailsMap[activity.id]?.barcodesList" maxItems="1"></app-bringoz-items-list-display>
                </ng-container>
              </div>

              <!-- Labels Column -->
              <div *ngIf="settings?.route?.columns?.labels" class="td col-labels">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="label-outline" classSize="md" fill="#484848"></bringoz-icon>
                  <app-bringoz-labels-display *ngIf="activityDetailsMap[activity.id]?.labels?.length" [labels]="activityDetailsMap[activity.id]?.labels" maxItems="1"></app-bringoz-labels-display>
                  <span *ngIf="!activityDetailsMap[activity.id]?.labels?.length" class="text-ellipsis">---</span>
                </ng-container>
              </div>

              <!-- Vehicles Column -->
              <div *ngIf="settings?.route?.columns?.vehicles" class="td col-vehicles">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <bringoz-icon iconName="privatecar" classSize="md" fill="#484848"></bringoz-icon>
                  <app-bringoz-items-list-display *ngIf="activityDetailsMap[activity.id]?.firstJob" [itemsList]="{list: activityDetailsMap[activity.id]?.firstJob.allowedVehicleReferences, displayKey: 'name'}" maxItems="1"></app-bringoz-items-list-display>
                  <span *ngIf="!activityDetailsMap[activity.id]?.firstJob">---</span>
                </ng-container>
              </div>

              <!-- Recurring Service Column -->
              <div *ngIf="settings?.route?.columns?.recurringServiceTemplateId" class="td col-recurring">
                <span *ngIf="activity.type === 'START' || activity.type === 'END'">---</span>
                <ng-container *ngIf="activity.type !== 'START' && activity.type !== 'END'">
                  <ng-container *ngIf="activityDetailsMap[activity.id]?.firstJob?.serviceTemplateId">
                    <bringoz-icon iconName="recurring" class="gray-102" classSize="md"></bringoz-icon>
                    <app-bringoz-state-link class="text-ellipsis"
                                            [state]="'recurring-services'"
                                            [permission]="'recurring-service-template.list'"
                                            [params]="{queryString: activityDetailsMap[activity.id]?.firstJob.serviceTemplateId}"
                                            [text]="activityDetailsMap[activity.id]?.firstJob.serviceTemplateId">
                    </app-bringoz-state-link>
                  </ng-container>
                  <span *ngIf="!activityDetailsMap[activity.id]?.firstJob?.serviceTemplateId">---</span>
                </ng-container>
              </div>
            </ng-container>

            <!-- Drag Preview -->
            <div *cdkDragPreview class="tr drag-preview route-drilldown-drag-preview">
               <div class="td col-id">{{ activity.externalId || activity.jobId || activity.id }}</div>
               <div class="td col-address">{{ activity.address | bringozAddress }}</div>
            </div>

            <!-- Placeholder -->
            <div *cdkDragPlaceholder class="tr drag-placeholder"></div>

          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <app-bringoz-linear-progress *ngIf="!!isLoading || isRunning"></app-bringoz-linear-progress>
</div>
